export const dateToLocaleString = (date: string) => {
  const newDate = new Date(date);
  return newDate.toLocaleDateString("en-GB", {
    year: "numeric",
    month: "short",
    day: "2-digit",
  });
};
